export default {
  pages: {
    shippedItems: {
      title: 'Накладная',
      items: 'Товары',
      table: {
        name: 'Наименование',
        declaredQuantity: 'Заявленное кол-во',
        receivedQuantity: 'Полученное кол-во',
      },
      save: 'Сохранить',
      cancel: 'Отмена',
      cancelShipment: 'Отменить отгрузку',
      waybillFile: 'Файл накладной',
      open: 'Открыть',
      successResponse: 'Успешно сохранено',
    },
  },
};
